namespace $ {
	
	$.$mol_dom_context = self as any
	
}
